import Investment from './Investment'

class FeeInvestment extends Investment {
  get investment_returns(){
    return this.constructor.employeeStore.investment_returns.filter(ir => ir.investment_id === this.id)
  }
  set investment_returns(v){
    // return undefined
  }
  get name(){
    return 'Honorar'
  }
  get investments(){
    return []
  }
  set investments(v){
    
  }
}

export default FeeInvestment
